import apiClient from '../utils/api';

export interface SaveCategoryTreeData {
  vendorId: string;
  mainCategory?: string;
  subCategories: string[];
  types: string[];
  items: string[];
}

export interface SaveCategoryTreeResponse {
  success: boolean;
  message: string;
}

export const vendorServicesService = {
  /**
   * Save vendor category tree selections (Step 5 of onboarding)
   */
  saveCategoryTree: async (
    data: SaveCategoryTreeData
  ): Promise<SaveCategoryTreeResponse> => {
    const response = await apiClient.post<SaveCategoryTreeResponse>(
      `/vendors/${data.vendorId}/save-category-tree`,
      data
    );
    return response.data;
  },
};

